// extracted by mini-css-extract-plugin
export default {"loading-spinner":"Loading_style__loading-spinner___b4","appear":"Loading_style__appear___fd","stretchdelay":"Loading_style__stretchdelay___e3","inline":"Loading_style__inline___a7"};